<template> 
    <div v-if="showTestConectorPopup" class="background-popup" @click.self="closePopup()">
        <div class="popup-content">
            <div style="height: 17%; width: 100%; border-bottom: 2px solid #e7e7e7;">
                <div style="display: flex;align-items: center; justify-content: space-between; padding-top: 20px; padding-bottom: 15px; padding-left: 30px; padding-right: 30px;">
                    <span style="font-weight: 700; font-size: 23px;">Test de Conector</span>
                    <v-btn icon @click="closePopup()" style="width: 10px; height: 10px">
                        <AppIcon :src="require('../assets/close_popup.svg')" :size="29" style="width: 100%; height: 100%" />
                    </v-btn>
                </div>
                <transition name="fade">
                    <div v-show="showSuccess" style="display: flex; justify-content: center; align-items: center; height: 17; background-color: #00c012;">
                        <span style="color: #eeffee; font-size: 9px; font-weight: 700;">Finalizado con éxito</span>
                    </div>
                </transition>
                <div v-show="loading">
                    <v-progress-linear
                        :active="loading"
                        :value="loading_percentage"
                        color="var(--v-primaryLighter-base)"
                        height="17"
                        striped
                        readonly
                    >
                        <span v-if="reiniciando" style="font-size: 10px; color: rgba(53, 20, 87, 1); font-weight: 600;">Reiniciando...</span>
                        <span v-else style="font-size: 10px; color: rgba(53, 20, 87, 1); font-weight: 600;">Analizando...</span>
                    </v-progress-linear>
                </div>
                <!-- loading, connector_works_correctly, server_restart, server_restart_successful, server_restart_failed, no_connection_detected, no_cloud_connection, waiting_time  -->
            </div>
            <div style="display: flex; width: 100%; height: 82%;">
                <div v-if="pending_operations && pending_operations.length > 0" style="width: 60%; height: 100%; border-right: 2px solid #e7e7e7;">
                    <div style="padding-top: 20px; padding-left: 30px; padding-bottom: 10px;">
                        <span style="font-size: 18px; font-weight: 600;">Historial últimas operaciones</span>
                    </div>
                    <div style="height: 100%; width: 100%; padding-right: 30px">
                        <div style="width: 95%;">
                            <v-row style="padding-left: 40px;">
                                <v-col cols="2" class="table-headers" style="border-top-left-radius: 5px;">
                                    Empresa
                                </v-col>
                                <v-col cols="6" class="table-headers">
                                    Funcionalidad
                                </v-col>
                                <v-col cols="4" class="table-headers" style="border-top-right-radius: 5px;">
                                    Fecha
                                </v-col>
                            </v-row>
                        </div>
                        <div style="max-height: 65%; width: 94%; overflow-y: auto; overflow-x: hidden; scrollbar-width: thin; scrollbar-color: #888 #e7e7e7; border: 1px solid #d1d1d1; margin-left: 28px; border-bottom-left-radius: 5px; border-bottom-right-radius: 5px;">
                            <v-row v-for="(operation, i) in pending_operations" :key="operation.id">
                                <v-col cols="2" :class="i%2==0?'table-cell-others2': 'table-cell-others1'" style="display: flex; justify-content: center;"> 
                                    {{operation.id}}
                                </v-col>
                                <v-col cols="6" :class="i%2==0?'table-cell-others2': 'table-cell-others1'" style="padding-left: 17px;">
                                    {{operation.name}}
                                </v-col>
                                <v-col cols="4" :class="i%2==0?'table-cell-others2': 'table-cell-others1'" style="padding-left: 0px;">
                                    {{formatDate(operation.written)}}
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                </div>
                <div v-else style="width: 60%; height: 100%; display: flex; align-items: center; justify-content: center; border-right: 2px solid #e7e7e7;">
                    <v-progress-circular indeterminate color="primary" size="30"/>
                </div>
                
                <div style="width: 40%; height: 100%; display: flex; justify-content: center; align-items: center;">
                    <!-- loading -->
                    <div v-if="connector_status=='loading'" style="display: flex; flex-direction: column; align-items: center; padding: 0vh 12%;">
                        <div style="padding-bottom: 7vh; height: 48px; width: 48px; margin-bottom: 8%;">
                            <AppIcon :src="require('../assets/page_control.svg')" :size="29" />
                        </div>
                        <span style="text-align: center;font-weight: 500;">
                            En unos minutos terminamos el test, gracias por la paciencia.
                        </span>
                    </div>
                    <!-- connector_works_correctly -->
                    <div v-else-if="connector_status=='connector_works_correctly'" style="display: flex; flex-direction: column; align-items: center; padding: 0vh 12%;">
                        <div style="height: 48px; width: 48px; margin-bottom: 6%;">
                            <AppIcon :src="require('../assets/check_circle.svg')" :size="29" style="height: 100%; width: 100%;" />
                        </div>
                        <span style="text-align: center;font-weight: 600; font-size: 24px; color: #003407; padding-bottom: 5%; line-height: 1.1;">
                            El conector funciona correctamente
                        </span>
                        <span class="description">
                            Hemos hecho un test de conector analizando todo tu historial de funcionalidades la operación a concluido exitosamente.
                        </span>
                        <v-btn
                            class="text-none styleButton" 
                            outlined
                            color="#454545"
                            @click="closePopup()"
                        >
                            Aceptar
                        </v-btn>
                    </div>
                    <!-- server_restart -->
                    <div v-else-if="connector_status=='server_restart'" style="display: flex; flex-direction: column; align-items: center; padding: 0vh 12%;">
                        <div style="padding-bottom: 7vh; height: 48px; width: 48px; margin-bottom: 8%;">
                            <AppIcon :src="require('../assets/reset_wrench.svg')" :size="29" />
                        </div>
                        <span class="title">
                            Reinicio del servicio
                        </span>
                        <span class="description">
                            Hemos realizado un análisis completo del conector y del historial de funcionalidades. Para asegurar su correcto funcionamiento, es necesario reiniciar el servicio.
                        </span>
                        <v-btn
                            :disabled="loading"
                            class="text-none styleButton" 
                            :color="loading? 'rgba(244, 244, 244, 0.05)':'#7339b7'"
                            @click="handleRestartService()"
                        >
                            <span style="color: white">Reiniciar</span>
                        </v-btn>
                    </div>
                    <!-- server_restart_successful -->
                    <div v-else-if="connector_status=='server_restart_successful'" style="display: flex; flex-direction: column; align-items: center; padding: 0vh 12%;">
                        <div style="padding-bottom: 7vh; height: 48px; width: 48px; margin-bottom: 8%;">
                            <AppIcon :src="require('../assets/reset_successful.svg')" :size="29" />
                        </div>
                        <span class="title">
                            Reinicio del servicio exitoso
                        </span>
                        <span class="description">
                            Hemos reiniciado el servicio y todo parece funcionar correctamente. Verifica si todo está operando como se espera de tu lado.
                        </span>
                        <v-btn
                            outlined
                            class="text-none styleButton" 
                            color="#454545"
                            @click="closePopup()"
                        >
                            <span style="font-size: 14px;">Aceptar</span>
                        </v-btn>
                    </div>
                    <!-- server_restart_failed -->
                    <div v-else-if="connector_status=='server_restart_failed'" style="display: flex; flex-direction: column; align-items: center; padding: 0vh 12%;">
                        <div style="padding-bottom: 7vh; height: 48px; width: 48px; margin-bottom: 8%;">
                            <AppIcon :src="require('../assets/reset_failed.svg')" :size="29" />
                        </div>
                        <span class="title">
                            Reinicio del servicio fallido
                        </span>
                        <span class="description">
                            Se intentó reiniciar el conector, pero la operación no fue exitosa. Te recomendamos contactar con el soporte técnico para una revisión más detallada del problema.
                        </span>
                        <v-btn
                            class="text-none styleButton" 
                            color="#4f4f4f"
                            @click="openChat()"
                        >
                            <span style="color: white">Contactar con soporte</span>
                        </v-btn>
                    </div>
                    <!-- no_connection_detected -->
                    <div v-else-if="connector_status=='no_connection_detected'" style="display: flex; flex-direction: column; align-items: center; padding: 0vh 12%;">
                        <div style="padding-bottom: 7vh; height: 48px; width: 48px; margin-bottom: 3%;">
                            <AppIcon :src="require('../assets/power_settings_circle.svg')" :size="29" />
                        </div>
                        <span class="title">
                            No se detecta conexión
                        </span>
                        <span class="description" style="margin-bottom: 6%;">
                            Actualmente no podemos detectar actividad desde el ordenador/servidor donde está instalado el conector. Asegúrate de que el equipo esté encendido y conectado a internet. Si el equipo está encendido, contacta con soporte técnico.
                        </span>
                        <v-btn
                            outlined
                            class="text-none styleButton" 
                            color="#454545"
                            @click="closePopup()"
                        >
                            <span style="font-size: 14px;">Aceptar</span>
                        </v-btn>
                        <v-btn
                            class="text-none styleButton" 
                            color="#7339b7"
                            @click="openChat()"
                        >
                            <span style="color: white; font-size: 14px;">Contactar soporte</span>
                        </v-btn>
                        <button
                            @click="closePopup()"
                        >
                            <AppIcon :src="require('../assets/opened_book.svg')" :size="29" />
                        </button>
                    </div>
                    <!-- no_cloud_connection -->
                    <div v-else-if="connector_status=='no_cloud_connection'" style="display: flex; flex-direction: column; align-items: center; padding: 0vh 12%;">
                        <div style="padding-bottom: 20%; height: 48px; width: 48px; margin-bottom: 3%;">
                            <AppIcon :src="require('../assets/cloud_alert.svg')" :size="29" />
                        </div>
                        <span class="title">
                            Conexión en la nube sin respuesta
                        </span>
                        <span v-if="restart_cloud_failed" class="description" style="margin-bottom: 17%;">
                            No se puede reiniciar el servidor en este momento. La conexión con la nube no responde. Por favor, inténtalo más tarde o contacta con soporte técnico.
                        </span>
                        <span v-else class="description" style="margin-bottom: 17%;">
                            No se puede establecer comunicación con el servidor en la nube en este momento. Intenta reiniciar el conector haciendo clic en el botón 'Reiniciar'.
                        </span>
                        <v-btn
                            v-if="restart_cloud_failed"
                            class="text-none styleButton" 
                            color="#7339b7"
                            @click="openChat()"
                        >
                            <span style="color: white; font-size: 14px;">Contactar soporte</span>
                        </v-btn>
                        <v-btn
                            v-else
                            :disable="reiniciando"
                            class="text-none styleButton" 
                            color="#7339b7"
                            @click="handleRestartCloud()"
                        >
                            <span style="color: white; font-size: 14px;">Reiniciar</span>
                        </v-btn>
                    </div>
                    <!-- waiting_time -->
                    <div v-else-if="connector_status=='waiting_time'" style="display: flex; flex-direction: column; align-items: center; padding: 0vh 12%;">
                        <div style="padding-bottom: 20%; height: 48px; width: 48px; margin-bottom: 3%;">
                            <AppIcon :src="require('../assets/clock_paused.svg')" :size="29" />
                        </div>
                        <span v-if="wait_20_min" class="title">
                            Reinicio en espera
                        </span>
                        <span v-else class="title">
                            El test necesita un tiempo de espera para volver a ser ejecutado.
                        </span>
                        <span v-if="wait_20_min" class="description" style="margin-bottom: 17%;">
                            Por razones técnicas, no es posible reiniciarlo de nuevo hasta que pasen al menos 20 minutos desde el último intento.
                        </span>
                        <span v-else class="description" style="margin-bottom: 17%;">
                            Es necesario esperar 15 minutos para volver a lanzar el test.
                        </span>
                        <v-btn
                            outlined
                            class="text-none styleButton" 
                            color="#454545"
                            @click="closePopup()"
                        >
                            <span style="font-size: 14px;">Aceptar</span>
                        </v-btn>
                        <v-btn
                            class="text-none styleButton" 
                            color="#7339b7"
                            @click="openChat()"
                        >
                            <span style="color: white; font-size: 14px; font-weight: 500;">Contactar soporte</span>
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<!-- loading, connector_works_correctly, server_restart, server_restart_successful, server_restart_failed, no_connection_detected, no_cloud_connection, waiting_time  -->

<script>
import { client, sync_command_dispatcher, async_command_dispatcher } from "@/api/client";

export default {
    name: "TestConectorPopup",
    props: {
        showTestConectorPopup: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: false,
            loading_percentage: 0,
            pending_operations: [],
            operation_state: "all",
            operation_name: "",
            operation_limit: null,
            connector_status: "loading",
            showSuccess: false,
            reiniciando: false,
            restart_cloud_failed: false,
            wait_20_min: false
        };
    },
    watch: {
        connector_status(newVal) {
            if (['connector_works_correctly', 'server_restart', 'no_connection_detected', 'no_cloud_connection', 'waiting_time'].includes(newVal)) {
                this.showSuccess = true;
                setTimeout(() => {
                    this.showSuccess = false;
                }, 3000);
            }
        }
    },
    async mounted() {
        await this.get_operations();
        await this.connectorDiagnosis();
        console.log("this.pending_operations", this.pending_operations)
    },
    methods: {
        closePopup(){
            this.$emit("closePopup", false)
        },
        async get_operations(){
            let filter = '?order_by=-written';
            if(this.operation_state != "all") filter += '&state=' + this.operation_state;
            if (this.operation_name) filter += '&name=' + this.operation_name;
            if (this.operation_limit) filter += '&limit=' + this.operation_limit;

            const response = await client.get("operations_debug/" + filter);
            this.pending_operations = response.data.results;
        },
        async connectorDiagnosis() {
            try {
                this.loading = true;
                this.loading_percentage = 0;

                const interval = setInterval(() => {
                    if(this.loading_percentage < 96) {
                        this.loading_percentage += 100/30; //tiempo de espera son 30 seg por llamada
                    }
                }, 1000)

                const result = await sync_command_dispatcher.dispatch("connector.diagnosis", {})
                await this.get_operations()
                console.log("test conector: ", result)

                this.connector_status = result.output.status
                this.loading_percentage = 100;
                this.loading = false;
                clearInterval(interval)
            } catch(error) {
                console.error("Error al obtener operaciones:", error);
                if (interval) clearInterval(interval);
                this.loading_percentage = 0;
                this.loading = false;
            }
        },
        async handleRestartService() {
            try {
                this.loading = true;
                this.loading_percentage = 0;
                this.reiniciando = true;

                console.log("Reiniciando el conector...")

                const interval = setInterval(() =>{
                    if(this.loading_percentage < 96){
                        this.loading_percentage += 100/30;
                    }
                }, 1000)
                const result = await sync_command_dispatcher.dispatch("restart.service.ws", {})
                await this.get_operations()
                console.log("Reinicio del conector: ", result)

                this.connector_status = result.output.status


                this.loading_percentage = 100;
                this.loading = false;
                this.reiniciando = false;
                clearInterval(interval)
            } catch(error) {
                console.error("Error al reiniciar el servidor:", error);
                if (interval) clearInterval(interval);
                this.loading_percentage = 0;
                this.loading = false;
                this.reiniciando = false;
            }
        },
        async handleRestartCloud(){
            try {
                this.loading = true;
                this.loading_percentage = 0;
                this.reiniciando = true;

                console.log("Reiniciando el conector de nube...")

                const interval = setInterval(() =>{
                    if(this.loading_percentage < 96){
                        this.loading_percentage += 100/30;
                    }
                }, 1000)
                const result = await sync_command_dispatcher.dispatch("restart.cloud.connector.command", {})

                console.log("result: ", result)
                if(result.output.status == "waiting_time"){
                    this.wait_20_min = true
                }

                this.connector_status = result.output.status

                this.loading_percentage = 100;
                this.loading = false;
                this.reiniciando = false;
                clearInterval(interval)
            } catch(error) {
                console.error("Error al reiniciar el servidor:", error);
                if (interval) clearInterval(interval);
                this.loading_percentage = 0;
                this.loading = false;
                this.reiniciando = false;
            }
        },
        formatDate(dateString) {
            const date = new Date(dateString)
            const day = String(date.getDate()).padStart(2, "0")
            const month = String(date.getMonth() + 1).padStart(2, "0")
            const year = date.getFullYear()
            const hours = String(date.getHours()).padStart(2, "0")
            const minutes = String(date.getMinutes()).padStart(2, "0")
            const seconds = String(date.getSeconds()).padStart(2, "0")
            return day+"-"+month+"-"+year+" "+hours+":"+minutes+":"+seconds
        },
        openChat() {
            try {        
                window.$crisp.push(["do", "chat:open"]);         
            }
            catch {}
        }
    }
};
</script>

<style scoped>
    .background-popup {
        position:fixed !important;
        top: 0 !important;
        left: 0 !important;
        width: 100% !important;
        height: 100% !important;
        background-color: rgba(6, 6, 71, 0.8) !important;
        display: flex !important;
        justify-content: center !important;
        align-items: center !important;
        z-index: 9998 !important;
    }

    .popup-content {
        background-color: white !important;
        border-radius: 10px !important;
        width: 60vw !important;
        height: 70vh !important;
        z-index: 9999 !important;
        box-shadow: 0 0 30px rgba(255,255,255, 0.6) !important;
        color: rgba(79, 79, 79, 1) !important;
        font-size: 16px !important;
        font-weight: 400 !important;
        font-family: "Roboto";
    }
    .table-headers {
        background-color: #e7e7e7 !important;
        border: 1px solid #d1d1d1 !important;
        color: #262626 !important;
        font-weight: 700 !important;
        font-size: 12px !important;
    }

    .table-cell-others1 {
        background-color: #ffffff !important;
        border: 1px solid #ffffff !important;
        color: #6d6d6d !important;
        font-weight: 400 !important;
        font-size: 12px !important;
    }

    .table-cell-others2 {
        background-color: #f3f3f3 !important;
        border: 1px solid #f3f3f3 !important;
        color: #6d6d6d !important;
        font-weight: 400 !important;
        font-size: 12px !important;
    }

    .description {
        text-align: center;
        font-weight: 500;
        font-size: 12px;
        margin-bottom: 16%;
        line-height: 1.3;
    }

    .title {
        text-align: center;
        font-weight: 600;
        font-size: 24px;
        color: #512a79;
        margin-bottom: 5%;
        font-family: "Roboto";
        line-height: 1.1;
    }

    .styleButton {
        width: 70%; 
        margin-bottom: 5%; 
        border-radius: 10px;
    }

    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
</style>